import { AsyncState } from '../state/types';
import { AsyncStateOptions } from '../types/Options';
import { AsyncStateStatus } from '../status/types';

export function createAsyncState<T = void>(options?: AsyncStateOptions<T>): AsyncState<T> {
	return {
		actionStatus: options?.actionStatus ?? AsyncStateStatus.Idle,
		data: options?.data,
		statusCode: options?.statusCode
	};
}
